const COMPANIES = [
  "Stockholms Hundhotell",
  "Tassträff",
  "Vovvevillan",
  "Nordic Paws",
  "Kennel Björk",
  "Dagis Drevet",
  "Hundgården AB",
  "Lufsen & Co",
];

export default function LogoMarquee() {
  return (
    <section data-testid="logo-marquee" className="relative py-12 border-y border-slate-200 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/30 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <p className="text-center text-xs uppercase tracking-[0.22em] font-semibold text-slate-500 dark:text-slate-400 mb-8">
          Litet förtroende från Sveriges ledande hundverksamheter
        </p>
        <div className="relative overflow-hidden mask-fade">
          <div className="flex w-max animate-marquee gap-16">
            {[...COMPANIES, ...COMPANIES].map((name, i) => (
              <div
                key={i}
                className="font-display text-xl md:text-2xl font-semibold text-slate-400 dark:text-slate-500 whitespace-nowrap"
              >
                {name}
              </div>
            ))}
          </div>
        </div>
      </div>
      <style>{`.mask-fade{ -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent); mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent); }`}</style>
    </section>
  );
}
